"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "messages", {
  enumerable: true,
  get: function get() {
    return _messages.messages;
  }
});
Object.defineProperty(exports, "LOCALE_CODES", {
  enumerable: true,
  get: function get() {
    return _locales.LOCALE_CODES;
  }
});
Object.defineProperty(exports, "LOCALES", {
  enumerable: true,
  get: function get() {
    return _locales.LOCALES;
  }
});
Object.defineProperty(exports, "FormattedMessage", {
  enumerable: true,
  get: function get() {
    return _formattedMessage["default"];
  }
});

var _messages = require("./messages");

var _locales = require("./locales");

var _formattedMessage = _interopRequireDefault(require("./formatted-message"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBOztBQUNBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuZXhwb3J0IHttZXNzYWdlc30gZnJvbSAnLi9tZXNzYWdlcyc7XG5leHBvcnQge0xPQ0FMRV9DT0RFUywgTE9DQUxFU30gZnJvbSAnLi9sb2NhbGVzJztcbmV4cG9ydCB7ZGVmYXVsdCBhcyBGb3JtYXR0ZWRNZXNzYWdlfSBmcm9tICcuL2Zvcm1hdHRlZC1tZXNzYWdlJztcbiJdfQ==